module.exports = __webpack_public_path__ + "static/media/Education - Digital Health.1acdfccd.svg";